document.addEventListener('DOMContentLoaded', function () {
  const video = document.querySelector('.video-hero__video');
  const forms = document.querySelectorAll(".video-hero__form_content");

  forms.forEach((form) => {
    const input = form.querySelector(".video-hero__form_input");
    const button = form.querySelector(".video-hero_btn_form");
    const dataFrom = input.dataset.from;
    const dataId = input.dataset.id;
    if (!input || !button) return;
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const email = input.value.trim();
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!email) {
        alert("Please enter an email address");
        return;
      }
      if (!isValidEmail) {
        alert("Invalid email address");
        return;
      }
      setCookieform("user_email", email, 365);
      //setCookieform("custom_value", "10.00", 365);
      const url = button.getAttribute("data-href");
      if (url) {
        const options = {
          method: 'POST',
          headers: {
            revision: '2026-01-15',
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json'
          },
          body: `{
                "data": {
                  "type": "subscription",
                  "attributes": {
                    "profile": {
                      "data": {
                        "type": "profile",
                        "attributes": {
                          "email": "${email}",
                          "properties": {
                            "tag": "${dataFrom}"
                          }
                        }
                      }
                    }
                  },
                  "relationships": {
                    "list": {
                      "data": {
                        "type": "list",
                        "id": "${dataId}"
                      }
                    }
                  }
                }
              }`
            };

        fetch('https://a.klaviyo.com/client/subscriptions?company_id=U4fELX', options)
        .then(res => {
            if (!res.ok) {
              throw new Error('Error');
            }
            return res.json();
          })
          .then(data => {
            console.log('Success:', data);
            window.location.href = url;
          })
          .catch(err => {
            console.error('Error:', err);
          });

        setTimeout(() => {
          window.location.href = url;
        }, 1500);
      }
    });

    input.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        button.click();
      }
    });
  });
});

function setCookieform(name, value, days) {
  document.cookie = `custom_value=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
}